import mailSearchStore from '../store/store';

export default function shouldForceOfflineSearchBasedOnTimestamp(): boolean {
    const forceOfflineSearchTimestamp = mailSearchStore.forceOfflineSearchTimestamp;
    return !!forceOfflineSearchTimestamp && Date.now() < forceOfflineSearchTimestamp;
}
